<template>
  <b-container>
    <b-row class="mx-auto">
      <b-col cols="12">
        <label for="answer" class="mb-3 title-question-list" v-html="question.title" style="text-align: justify;"></label>
      </b-col>
      <b-col sm="12" md="8" lg="8" xl="8" class="mx-auto">
        <b-form-select v-model="question.value" :options="valuesFormatted">
          <option :value="null" disabled>Please select an option</option>
        </b-form-select>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    question: {
      type: Object,
      required: true
    },
  },
  data () {
    return {
      selected: false,
      valuesFormatted: [],
    };
  },
  mounted () {
    this.formatList();  
  },
  methods: {
    formatList () {
      for (let index = 0; index < this.question.options.length; index++) {
        this.valuesFormatted.push(this.question.options[index].title);
      }
    },
  },

};
</script>

<style lang="css">
.smiley {
  width: 100%;
  cursor: pointer;
}
.title-question-list {
    margin-bottom: 1rem;
    font-size: 20px;
    font-weight: bold;
  }
@media only screen and (orientation: portrait) and (max-width: 475px)  {
  .title-question-list {
    margin-bottom: 1rem;
    font-size: 16px;
    font-weight: bold;
  }
}
</style>


// WEBPACK FOOTER //
// src/surveys/components/List.vue